'use strict';

exports.__esModule = true;
exports['default'] = {
  background: {
    image: '/background.jpg',
    size: 'cover'
  },
  props: {},
  title: 'Polo Mundial',
  type: 'Home'
};
module.exports = exports['default'];